<template>
  <div class="content-menu is-hidden-mobile" :class="{ open: open }">
    <button
      class="button button-menu is-link"
      :class="{ 'is-hidden': open }"
      v-on:click="open = !open"
    >
      <i class="material-icons">info</i>
    </button>
    <div class="minimal-panel">
      <div ref="menuInterLider" class="panel-header">
        <div class="header-content">
          <h2 class="panel-title">Definiciones</h2>
          <div class="breadcrumb" v-if="currentSubtitle">
            <span class="breadcrumb-item">{{ currentSubtitle }}</span>
          </div>
        </div>

        <button
          class="nav-button"
          @click="goBack"
          v-if="currentView !== 'main'"
        >
          <i class="material-icons">subdirectory_arrow_left</i>
        </button>
        <button class="nav-button" @click="togglePanel" v-else>
          <i class="material-icons">close</i>
        </button>
      </div>

      <!-- Vista principal -->
      <div ref="menuInterLider" class="panel-content" v-if="currentView === 'main'">
        <div class="categories-container">
          <div
            v-for="cat in categoriasList"
            :key="cat.key"
            class="category-item"
            @click="selectCategoria(cat)"
          >
            <div class="category-content">
              <div class="category-icon">
                <i class="material-icons">{{ cat.icon }}</i>
              </div>
              <div class="category-info">
                <h3 class="category-name">{{ cat.title }}</h3>
                <span class="items-count">
                  {{ cat.childCount ? `${cat.childCount} elementos` : "-" }}
                </span>
              </div>
            </div>
            <div class="category-arrow">
              <i class="material-icons">arrow_forward</i>
            </div>
          </div>
        </div>
      </div>

      <!-- Vista de categoría -->
      <div
        ref="menuInterLider"
        class="panel-content"
        v-else-if="currentView === 'category' && categoriaActual"
      >
        <div class="category-detail">
          <div class="general-info-section">
            <div class="info-header">
              <div class="info-icon">
                <i class="material-icons">{{ iconos[categoriaActual.key] || "label" }}</i>
              </div>
              <h3 class="info-title">{{ categoriaActual.title }}</h3>
            </div>

            <div class="info-content" v-if="categoriaActual.def">
              <div class="info-item">
                <div class="info-label">
                  <i class="material-icons">import_contacts</i>
                  <span>Definición</span>
                </div>
                <p class="info-text">{{ categoriaActual.def }}</p>
              </div>

              <div class="info-item" v-if="categoriaActual.masInfo">
                <div class="info-label">
                  <i class="material-icons">lightbulb_outline</i>
                  <span>Más sobre esta variable</span>
                </div>
                <p class="info-text">{{ categoriaActual.masInfo }}</p>
              </div>
            </div>
          </div>

          <div v-if="categoriaActual.hijos.length">
            <div class="section-header">
              <h4 class="section-title">Elementos</h4>
              <span class="section-count">{{ categoriaActual.hijos.length }}</span>
            </div>

            <div class="subitems-container">
              <div
                v-for="hijo in categoriaActual.hijos"
                :key="hijo.key"
                class="subitem-card"
                @click="selectSubitem(hijo)"
              >
                <div class="subitem-header">
                  <h5 class="subitem-title">{{ hijo.title }}</h5>
                  <i class="material-icons subitem-arrow">arrow_forward</i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Vista de subitem -->
      <div
        ref="menuInterLider"
        class="panel-content"
        v-else-if="currentView === 'subitem' && subitemActual"
      >
        <div class="subitem-detail">
          <div class="subitem-detail-header">
            <h3 class="subitem-detail-title">{{ subitemActual.title }}</h3>
          </div>

          <div class="subitem-info-section" v-if="subitemActual.def">
            <div class="info-item">
              <div class="info-label">
                <i class="material-icons">import_contacts</i>
                <span>Definición</span>
              </div>
              <p class="info-text">{{ subitemActual.def }}</p>
            </div>

            <div class="info-item" v-if="subitemActual.masInfo">
              <div class="info-label">
                <i class="material-icons">lightbulb_outline</i>
                <span>Más sobre esta variable</span>
              </div>
              <p class="info-text">{{ subitemActual.masInfo }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import json from './calificacionLider.json'
import { estructura, nombres, iconos } from './helpers/estructuraLider'

export default {
  name: 'MenuInterpretacionesLider',
  data () {
    return {
      open: false,
      currentView: 'main',
      currentCategoria: null,
      currentSubitem: null,
      currentSubtitle: '',
      definiciones: json.definiciones,
      estructura,
      nombres,
      iconos
    }
  },
  computed: {
    categoriasList () {
      return this.estructura.categorias.map((key) => ({
        key,
        title: this.nombres[key],
        icon: this.iconos[key] || 'label',
        childCount: (this.estructura[key] || []).length
      }))
    },
    categoriaActual () {
      if (!this.currentCategoria) return null
      const hijos = (this.estructura[this.currentCategoria] || []).map((key) => ({
        key,
        title: this.nombres[key]
      }))
      return {
        key: this.currentCategoria,
        title: this.nombres[this.currentCategoria],
        ...this.definiciones[this.currentCategoria],
        hijos
      }
    },
    subitemActual () {
      if (!this.currentSubitem) return null
      return {
        key: this.currentSubitem,
        title: this.nombres[this.currentSubitem],
        ...this.definiciones[this.currentSubitem]
      }
    }
  },
  methods: {
    selectCategoria (cat) {
      this.currentCategoria = cat.key
      this.currentView = 'category'
      this.currentSubtitle = cat.title
      this.resetScroll()
    },
    selectSubitem (hijo) {
      this.currentSubitem = hijo.key
      this.currentView = 'subitem'
      this.currentSubtitle = `${this.nombres[this.currentCategoria]} / ${hijo.title}`
      this.resetScroll()
    },
    goBack () {
      if (this.currentView === 'subitem') {
        this.currentView = 'category'
        this.currentSubitem = null
        this.currentSubtitle = this.nombres[this.currentCategoria]
      } else if (this.currentView === 'category') {
        this.currentView = 'main'
        this.currentCategoria = null
        this.currentSubtitle = ''
      }
      this.resetScroll()
    },
    resetScroll () {
      this.$nextTick(() => {
        if (this.$refs.menuInterLider) {
          this.$refs.menuInterLider.scrollTo({ top: 0, behavior: 'smooth' })
        }
      })
    },
    togglePanel () {
      this.open = false
    }
  }
}
</script>

<style scoped>
.content-menu {
  top: 0;
  right: -360px;
  display: flex;
  position: fixed;
  transition: right 0.3s ease;
  z-index: 60;
}

.button-menu {
  top: 23px;
  width: 60px;
  padding-right: 20px;
  right: -10px;
}

.open {
  right: 0 !important;
}

.minimal-panel {
  width: 360px;
  max-width: 100vw;
  height: 100vh;
  background: #ffffff;
  border-left: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.panel-header {
  padding: 20px 16px;
  border-bottom: 1px solid #f3f4f6;
  display: flex;
  align-items: center;
  gap: 16px;
  background: #fafafa;
}

.nav-button {
  width: 40px;
  height: 40px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #ffffff;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}

.nav-button:hover {
  background: #f9fafb;
  border-color: #d1d5db;
  color: #374151;
}

.header-content {
  flex: 1;
  min-width: 0;
}

.panel-title {
  font-size: 24px;
  font-weight: 600;
  margin: 0;
  color: #111827;
  line-height: 1.2;
}

.breadcrumb {
  margin-top: 4px;
}

.breadcrumb-item {
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;
  white-space: normal;
  word-break: break-word;
}

.panel-content {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
}

.categories-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.category-item {
  padding: 16px;
  border: 1px solid #f3f4f6;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
}

.category-item:hover {
  border-color: #e5e7eb;
  background: #f9fafb;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.category-content {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}

.category-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  font-size: 16px;
}

.category-info {
  flex: 1;
}

.category-name {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 2px 0;
  color: #111827;
}

.items-count {
  font-size: 13px;
  color: #6b7280;
  font-weight: 500;
}

.category-arrow {
  color: #9ca3af;
  font-size: 14px;
  transition: all 0.2s ease;
}

.category-item:hover .category-arrow {
  color: #6b7280;
  transform: translateX(2px);
}

.category-detail {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.general-info-section {
  background: #f9fafb;
  border: 1px solid #f3f4f6;
  border-radius: 12px;
  padding: 16px;
}

.info-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.info-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #522687;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
}

.info-icon .material-icons {
  font-size: 20px !important;
}

.info-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  color: #111827;
}

.info-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.info-label {
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-label i {
  color: #522687;
  font-size: 14px;
  width: 16px;
}

.info-label span {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

.info-text {
  text-align: justify;
  font-size: 14px;
  line-height: 1.5;
  color: #374151;
  margin: 0;
  white-space: pre-wrap;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  margin: 0;
}

.section-count {
  font-size: 12px;
  color: #6b7280;
  background: #f3f4f6;
  padding: 4px 8px;
  border-radius: 6px;
  font-weight: 500;
}

.subitems-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.subitem-card {
  padding: 16px;
  border: 1px solid #f3f4f6;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #ffffff;
}

.subitem-card:hover {
  border-color: #e5e7eb;
  background: #f9fafb;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.subitem-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.subitem-title {
  font-size: 15px;
  font-weight: 600;
  margin: 0;
  color: #111827;
}

.subitem-arrow {
  color: #9ca3af;
  font-size: 12px;
  transition: all 0.2s ease;
}

.subitem-card:hover .subitem-arrow {
  color: #6b7280;
  transform: translateX(2px);
}

.subitem-detail {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.subitem-detail-header {
  padding: 20px;
  background: #f9fafb;
  border-radius: 12px;
  border: 1px solid #f3f4f6;
}

.subitem-detail-title {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  color: #111827;
}

.subitem-info-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.panel-content::-webkit-scrollbar {
  width: 6px;
}

.panel-content::-webkit-scrollbar-track {
  background: #f9fafb;
}

.panel-content::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 3px;
}

.panel-content::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}
</style>



// WEBPACK FOOTER //
// src/components/lideres/MenuInterpretacionesLider.vue